import { render } from "./company-users.vue?vue&type=template&id=82d05237"
import script from "./company-users.vue?vue&type=script&lang=js"
export * from "./company-users.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__